import { useEffect, useState } from 'react';
import { useService } from 'hooks/useService';
import Input from 'components/partials/Fields/Input';
import Button from 'components/partials/Fields/Button';
import { general_error_toastr } from 'components/partials/Notification';
import FormTools from 'components/partials/Fields/FormTools';
import { useLoginContext } from '../../_context/useLoginContext';
import { SmsOptInModal } from 'components/UserAccount/SmsOptInModal';

const RequestNewCode = ({ requestNewCode }) => {
    const [timeLeft, setTimeLeft] = useState(true);

    useEffect(() => {
        setTimeLeft(true);
        const intervalId = setTimeout(() => {
            setTimeLeft(false);
        }, 60000);
        return () => clearTimeout(intervalId);
    }, []);
    const disabledStyles = { color: 'gray' };

    return (
        <a
            className={timeLeft ? 'disabled' : 'link'}
            style={timeLeft ? disabledStyles : {}}
            onClick={() => timeLeft || requestNewCode(false)}
        >
            Request a new code
        </a>
    );
};

const errorMessageMap = {
    invalid: 'You did not enter the expected verification code. Please try again.',
    expired: 'The verification code you entered has expired. Please request a new code.',
};

export const VerifyCode = ({ requestNewCode, phone = '' }) => {
    const { runChecksAndLogin } = useLoginContext();
    const [reason, setReason] = useState('');
    const [_value, setValue] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [showSmsOptInModal, setShowSmsOptInModal] = useState(false);
    const [_, fireVerifyOTP] = useService({ url: '/users/account/mfa/verify-otp' });

    const onChange = ({ target: { value } }) => setValue(value);

    const handleSubmit = () => {
        setReason('');
        setButtonDisabled(true);
        fireVerifyOTP({ params: { otp: _value } })
            .then((res) => {
                if (res.verified) {
                    return runChecksAndLogin(res);
                }

                setButtonDisabled(false);
                setReason(res.reason);
            })
            .catch((e) => {
                console.error(e);
                setButtonDisabled(false);
                general_error_toastr();
            });
    };

    useEffect(() => {
        window.$('#verify-code-input').focus();
    }, []);

    return (
        <div>
            {reason &&
                <div className="alert alert-warning">
                    <strong>Oops!</strong> {errorMessageMap[reason]}
                </div>
            }
            <div className="col text-center">
                <p>
                    Please enter the code sent to phone number ending
                    in {phone.substring(phone.length - 4, phone.length)} to
                    sign in to StorageTreasures.com.
                </p>
            </div>
            <br/>
            <form
                id="verify-code"
                onSubmit={e => e.preventDefault()}
                data-parsley-required-message="This field is required."
            >
                <FormTools
                    formID="verify-code"
                    onSubmit={handleSubmit}
                />
                <div className="col-md-offset-2 col-md-8 m-auto">
                    <Input
                        id="verify-code-input"
                        required
                        name="code"
                        mask="999999"
                        label="Verification Code"
                        value={_value}
                        attributes={{ onChange, moveCursorToEndOfUserInput: true }}
                    />
                </div>
                <div className="col text-center">
                    <Button
                        loading={buttonDisabled}
                        disabled={buttonDisabled}
                        type="submit"
                        variant="primary"
                        label="Verify Code"
                    />
                </div>
            </form>
            <div className="col text-center marginT15">
                <RequestNewCode requestNewCode={requestNewCode}/>
                <hr />
                <a className="link" onClick={() => setShowSmsOptInModal(true)}>
                    Didn't receive the code?
                </a>
            </div>
            <SmsOptInModal 
                show={showSmsOptInModal} 
                onClose={() => setShowSmsOptInModal(false)}
                mode="noPasscode"
                requestNewCode={requestNewCode}
            />
        </div>
    );
};
